// ▶ Em que modo a ficha do produto esta, e o que o botao do cabecalho faz.
//
// Decisao dela (D5, 02/09): a ficha ABRE MOSTRANDO, e so edita depois de tocar
// em "Editar". Tela que abre editavel e tela onde se apaga sem querer -- e a
// ficha do produto e a tela do app com mais campos.
export type ModoDaFicha = 'vendo' | 'editando'

export interface BotaoDoModo {
  rotulo: string
  proximo: ModoDaFicha
  /** A pergunta antes de trocar de modo. Nulo = troca direto. */
  confirma: string | null
}

export function modoInicialDaFicha(ehNovo: boolean): ModoDaFicha {
  // Produto novo nao tem o que visualizar: abrir "vendo" mostraria uma ficha
  // vazia com um botao Editar, que e um passo a toa.
  return ehNovo ? 'editando' : 'vendo'
}

export function botaoDoModo(modo: ModoDaFicha): BotaoDoModo {
  if (modo === 'vendo') return { rotulo: 'Editar', proximo: 'editando', confirma: null }
  // ⚠ Voltar para a visualizacao joga fora o que foi digitado e nao salvo. A
  // preocupacao de fundo dela nao e perder dado do servidor, e sim o app se
  // atrapalhar sozinho -- entao isto nao acontece com um toque so.
  return {
    rotulo: 'Cancelar',
    proximo: 'vendo',
    confirma: 'Descartar as alterações não salvas?',
  }
}
